<template>
    <div :class="getTaskClass()">
        <div class="bar" :class="getTaskProgressClass()" v-on:click="toggleProgress()" v-tooltip="getTaskProgressTooltip()"></div>
        <div class="body">
            <div class="actions">
                <file-upload
                        v-if="this.isEditing"
                        class="btn btn-link"
                        v-tooltip="'Attach file'"
                        :drop="true"
                        :multiple="true"
                        v-model="files"
                        :custom-action="fileUpload"
                        @input-file="inputFile"
                        ref="upload">
                    <i class="tim-icons icon-attach-87"></i>
                </file-upload>
                <button type="button" v-if="hasPermForBoard('add') && task.parent_id==0" rel="tooltip" v-on:click="addChildrenTask(task.id)" title="Add children task" class="btn btn-link" v-tooltip="isCreatingChildren ? 'Cancel creating task' : 'Add children task'">
                    <i :class="{'tim-icons': true, 'icon-simple-add': !isCreatingChildren, 'icon-simple-delete': isCreatingChildren}"></i>
                </button>
                <button type="button" v-if="hasPermForBoard('edit')" rel="tooltip" v-on:click="editTask(task.id)" title="Edit task" class="btn btn-link" v-tooltip="'Edit task'">
                    <i class="tim-icons icon-pencil"></i>
                </button>
                <button type="button" v-if="hasPermForBoard('delete') && !hasChildren(task.id)" v-on:click="deleteTask(task.id)" rel="tooltip" title="Delete task" class="btn btn-link" v-tooltip="'Delete task'">
                    <i class="tim-icons icon-simple-delete"></i>
                </button>
            </div>
            <div id="edit" v-if="isEditing">
                <div class="form-group" style="max-width:500px;">
                    <autocomplete v-bind:defaultValue="task.category" :search="search" placeholder="Category" ref="categoryInput" :get-result-value="getResultValue"></autocomplete>
                    <!-- <input type="text" v-on:keyup.enter="editTask()" v-model="category" class="form-control" placeholder="Category..." /> -->
                </div>
                <div class="form-group" style="max-width:500px;">
                    <input type="text" v-on:keyup.enter="editTask()" v-model="task.text" class="form-control" placeholder="Title..." />
                </div>
                <div class="form-group" style="max-width:500px;">
                    <input type="text" v-on:keyup.enter="editTask()" v-model="task.desc" class="form-control" placeholder="Description..." />
                </div>
            </div>
            <div id="show" v-if="!isEditing">
                <div class="title"><p class="name" style="display:inline;">
                    {{ task.text }}
                </p>
                    <p class="card-category-display d-inline">{{ task.category }}</p>
                    <img v-bind:src="task.creator_avatar" class="avatar ml-2" v-tooltip="task.creator_name" />
                </div>
                <p class="text-muted" style="min-height:21px;">{{ task.desc }}</p>
            </div>
        </div>
        <div class="images" v-if="getImages().length > 0">
            <div class="img" v-for="(file, index) in getImages()">
                <button type="button" rel="tooltip" class="btn btn-link" v-tooltip="'Delete image'" v-on:click="deleteFile(index)">
                    <i class="tim-icons icon-simple-delete"></i>
                </button>
                <img :src="file.url" />
            </div>
        </div>
        <div class="files" v-if="getFiles().length > 0">
            <div class="file" v-for="(file, index) in getFiles()" :key="file.id">
                <span class="size">{{getFileSize(file.size)}} MB</span>
                <span class="name">{{getFilename(file.name)}}</span>
                <span class="type">{{getExtension(file.name)}}</span>
                <button type="button" rel="tooltip" class="btn btn-link" v-tooltip="'Download'">
                    <i class="tim-icons icon-cloud-download-93"></i>
                </button>
                <button type="button" rel="tooltip" v-on:click="deleteFile(index)" class="btn btn-link" v-tooltip="'Delete'">
                    <i class="tim-icons icon-simple-delete"></i>
                </button>
            </div>
        </div>
        <div class="children">
            <TaskCreate v-show="isCreatingChildren" v-bind:task="task" @on-create="createTask" v-bind:categories="this.categories"></TaskCreate>
            <task v-for="taskChild in getChildren(task.id)"
                  :key="taskChild.id"
                  v-bind:taskindex="getTaskIndex(taskChild.id)"
                  v-bind:task="taskChild"
                  v-bind:boardid="getBoardId()"
                  child="1"
                  v-on="$listeners"
            ></task>
        </div>
        <div style="clear:both;"></div>
    </div>
</template>

<script>
import ApiService from "../common/api.service";
import TaskCreate from "../components/TaskCreate.vue"
import Task from "../components/Task.vue"
import axios from 'axios';
import FileUpload from 'vue-upload-component'

export default {
    name: 'task',
    props: ['task', 'child', 'taskindex', 'boardid', 'categories'],
    components: {
        Task,
        TaskCreate,
        FileUpload
    },
    beforeCreate: function(){
        this.$options.components.Task = Task;
    },
    data(){
        return {
            isCreatingChildren: false,
            animated: false,
            isEditing: false,
            category: '',
            progress: false,
            oldCategory: '',
            files: []
        }
    },
    mounted(){
        this.progress = this.task.progress;
    },
    methods: {
        hasPermForBoard(perm){
            return this.$root.hasPermForBoard(perm, this.boardid);
        },
        fileUpload(file, component){
           console.log(component);
        },
        getFileSize(size){
           return (size/1000000).toFixed(2);
        },
        getFilename(name){
            return name.split('.')[0];
        },
        getExtension(name){
            return name.split('.')[1];
        },
        getFiles(){
            return this.files.filter(x => x.url == null);
        },
        getImages(){
            return this.files.filter(x => x.url != null);
        },
        deleteFile(index){
            this.files.splice(index, 1);
        },
        inputFile(newFile, oldFile) {
            if (newFile && !oldFile) {
                // add
                if ( /\.(jpe?g|png|gif|bmp)$/i.test(newFile.name) )
                    newFile.url = URL.createObjectURL(newFile.file);

                console.log(newFile.data);
            }
            if (newFile && oldFile) {
                // update
                console.log('update', newFile)
            }
            if (!newFile && oldFile) {
                // remove
                console.log('remove', oldFile)
            }
        },
        search(input) {
            if (input.length < 1) { return [] }
            return this.categories.filter(cat => {
                return cat.title.toLowerCase().indexOf(input.toLowerCase()) !== -1
            })
        },
        getResultValue(result){
            return result.title;
        },
        addChildrenTask: function(){
            this.isCreatingChildren = !this.isCreatingChildren;
        },
        getBoardId: function(){
            return this.$parent.boardId;
        },
        getTaskIndex: function(taskId){
            return this.$parent.getTaskIndex(taskId);
        },
        getChildren: function(taskId){
            return this.$parent.getChildren(taskId);
        },
        hasChildren: function(taskId){
            return this.$parent.hasChildren(taskId);
        },
        createTask: function(text, category, desc, parent_id){
            this.$parent.createTask(text, category, desc, parent_id);
        },
        editTask: function(){
            let task = this.task;
            this.isEditing = !this.isEditing;
            if(this.isEditing) {
                this.category = task.category;
                this.progress = task.progress;
                this.oldCategory = task.category;
            } else {
                let newCategory = this.$refs.categoryInput.value;
                let data = {
                    id: task.id,
                    text: task.text,
                    desc: task.desc,
                    category: newCategory,
                    progress: this.progress
                };
                task.category = newCategory;
                task.progress = this.progress;

                axios.post(ApiService.getAction('tasks', 'edit', this.boardid), data).then((response) => { console.log(response) });
                this.$emit('on-edit', this.taskindex, this.task, this.oldCategory, newCategory);
            }
        },
        deleteTask: function(taskId){
            if(confirm("Do you want to delete this task? This can not be undone.")) {
                let data = { id: taskId };
                axios.post(ApiService.getAction('tasks', 'delete', this.boardid), data).then(response =>  { console.log(response) });
                this.$emit('on-delete', this.taskindex);
            }
        },
        getTaskClass: function(){
            return {
                task: true,
                'animated fadeIn faster': this.animated,
                child: this.child,
                uploading: this.$refs.upload && this.$refs.upload.dropActive
            };
        },
        getTaskProgressTooltip(){
            return (this.isEditing ? 'Mark as '+(this.progress<=0 ? 'finished' : 'TODO') : false);
        },
        getTaskProgressClass: function(){
            return {
                todo: this.progress<=0,
                finished: this.progress>0
            };
        },
        toggleProgress(){
            if(!this.isEditing) return;
            this.progress = (this.progress == 0 ? 100 : 0);
        }
    }
}
</script>
